import { ApolloClient } from "@apollo/client";
import {
  EventOccurrenceCommentCountDocument,
  EventOccurrenceCommentCountQuery,
  NewsPostCommentCountDocument,
  NewsPostCommentCountQuery,
} from "../../generated/gateway-client";
import { ContentType } from "../../lib/ContentType";

export const updateCommentCount = ({ contentType, contentUuid: uuid, client }: {
  contentType: ContentType;
  contentUuid: string;
  client: ApolloClient<any>;
}) => {
  switch (contentType) {
    case ContentType.NewsPost: {
      client.query<NewsPostCommentCountQuery>({
        query: NewsPostCommentCountDocument,
        variables: { uuid },
        fetchPolicy: "network-only",
      }).catch((e) => {
        console.error(e);
      })
      break;
    }
    case ContentType.EventPost: {
      client.query<EventOccurrenceCommentCountQuery>({
        query: EventOccurrenceCommentCountDocument,
        variables: { uuid },
        fetchPolicy: "network-only",
      }).catch((e) => {
        console.error(e);
      })
      break;
    }
  }
};
